import React from 'react'
import PropTypes from 'prop-types'

import ResolveProductPricing from 'Utils/ResolveProductPricing'
import Sticky from 'Pods/Shared/Sticky'

import ProductPriceStandard from './Components/ProductPriceStandard'
import ProductPriceFree from './Components/ProductPriceFree'
import ProductPriceBuyerLoyalty from './Components/ProductPriceBuyerLoyalty'
import ProductPriceSaleOff from './Components/ProductPriceSaleOff'

class ProductPrice extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      pricing: ResolveProductPricing(props),
      cart: props.cart,
      initialHeight: 0,
      topOffset: 0,
      isInCart: false,
      isPurchased: false,
    }

    this.priceBarRef = React.createRef()

    this.handleCartUpdate = this.handleCartUpdate.bind(this)
    this.checkItemPurchaseStatus = this.checkItemPurchaseStatus.bind(this)
  }

  componentDidMount() {
    const priceBox = this.priceBarRef.current.getBoundingClientRect()

    this.setState({
      initialHeight: priceBox.height,
      topOffset: document.getElementById('navigation-header').clientHeight,
    })

    App.events.subscribe('app:cart:updated', this.handleCartUpdate)

    this.checkItemPurchaseStatus()
  }

  isInCart(items) {
    return items.length > 0 && items.includes(Number(this.props.id))
  }

  handleCartUpdate(legacyCartResponseObject) {
    if (Object.keys(legacyCartResponseObject.meta).length > 0) {
      const isInCart = this.isInCart(legacyCartResponseObject.meta.itemIds)
      const cart = {
        isSignedIn: legacyCartResponseObject.meta.isSignedIn,
        value: isInCart ? this.state.cart.value : legacyCartResponseObject.meta.finalPrice,
        creditsAvailable: isInCart ? this.state.cart.creditsAvailable : legacyCartResponseObject.meta.storeCreditsLeft,
        applicableCldValue: legacyCartResponseObject.meta.minPurchaseAmountForCld,
        saleOffDiscount: legacyCartResponseObject.meta.saleOffDiscount,
        isSaleOff: legacyCartResponseObject.meta.saleCampaignActive,
        itemIds: legacyCartResponseObject.meta.itemIds,
      }

      this.setState(prevState => {
        return ({
          pricing: isInCart ? prevState.pricing : ResolveProductPricing({ ...this.props, cart }),
          cart,
          isInCart,
        })
      })
    }
  }

  checkItemPurchaseStatus() {
    axios.get(`/api/internal/items/${this.props.id}/check-purchased`)
      .then(response => this.setState({ isPurchased: response.data.isPurchased }))
      .catch((error) => {})
  }

  render() {
    return (
      <div ref={this.priceBarRef}>
        <Sticky
          className="product-pricing__sticky"
          position="top"
          stickyOffset={-this.state.initialHeight}
          offset={this.state.topOffset}
        >
          {this.state.pricing.price === 0 ? (
            <ProductPriceFree
              id={this.props.id}
              license={this.props.attributes.license}
              licenseText={this.props.license}
              title={this.props.attributes.title}
            />
          ) : (
            this.state.pricing.ribbon === 'CLD' && this.state.pricing.discount > 0 ? (
              <ProductPriceBuyerLoyalty
                id={this.props.id}
                originalPrice={this.state.pricing.originalPrice}
                discount={this.state.pricing.discount}
                finalPrice={this.state.pricing.price}
                acceptsPriceOffer={this.props.attributes.acceptsPriceOffer}
                hidePriceOffer={this.props.hidePriceOffer}
                page={this.props.page}
                storeCreditsLeft={this.state.cart.creditsAvailable}
                creditsCanBeApplied={this.props.attributes.isCLDApplicable}
                license={this.props.attributes.license}
                licenseText={this.props.license}
                isSignedIn={this.state.cart.isSignedIn}
                title={this.props.attributes.title}
                cartItems={this.state.cart.itemIds}
                isDisabled={this.state.isInCart}
                isPurchased={this.state.isPurchased}
              />
            ) : (
              this.state.pricing.ribbon === 'saleOff' ? (
                <ProductPriceSaleOff
                  id={this.props.id}
                  originalPrice={this.state.pricing.originalPrice}
                  finalPrice={this.state.pricing.price}
                  saleOffDiscount={this.state.pricing.discount}
                  acceptsPriceOffer={this.props.attributes.acceptsPriceOffer}
                  hidePriceOffer={this.props.hidePriceOffer}
                  page={this.props.page}
                  license={this.props.attributes.license}
                  licenseText={this.props.license}
                  isSignedIn={this.state.cart.isSignedIn}
                  title={this.props.attributes.title}
                  cartItems={this.state.cart.itemIds}
                  isDisabled={this.state.isInCart}
                  isPurchased={this.state.isPurchased}
                />
              ) : (
                <ProductPriceStandard
                  id={this.props.id}
                  finalPrice={this.state.pricing.price}
                  acceptsPriceOffer={this.props.attributes.acceptsPriceOffer}
                  hidePriceOffer={this.props.hidePriceOffer}
                  page={this.props.page}
                  storeCreditsLeft={this.state.cart.creditsAvailable}
                  creditsCanBeApplied={this.props.attributes.isCLDApplicable}
                  license={this.props.attributes.license}
                  licenseText={this.props.license}
                  isSignedIn={this.state.cart.isSignedIn}
                  title={this.props.attributes.title}
                  cartItems={this.state.cart.itemIds}
                  isDisabled={this.state.isInCart}
                  isPurchased={this.state.isPurchased}
                />
              )
            )
          )}
        </Sticky>
      </div>
    )
  }
}

ProductPrice.propTypes = {
  attributes: PropTypes.shape({
    price: PropTypes.number.isRequired,
    saleOffDiscount: PropTypes.number,
    isCLDApplicable: PropTypes.bool.isRequired,
    isSaleOffApplicable: PropTypes.bool.isRequired,
    license: PropTypes.object.isRequired,
  }).isRequired,
  cart: PropTypes.shape({
    value: PropTypes.number.isRequired,
    creditsAvailable: PropTypes.number.isRequired,
    applicableCldValue: PropTypes.number.isRequired,
    saleOffDiscount: PropTypes.number,
    isSaleOff: PropTypes.bool.isRequired,
  }),
}

export default ProductPrice
